// extracted by mini-css-extract-plugin
export default {"modal":"ImpersonateUserModal_modal__aZwWE","container":"ImpersonateUserModal_container__rpwkD"};